import { render, staticRenderFns } from "./List.vue?vue&type=template&id=5b70c751&scoped=true&"
import script from "./List.ts?vue&type=script&lang=ts&"
export * from "./List.ts?vue&type=script&lang=ts&"
import style0 from "./List.scss?vue&type=style&index=0&id=5b70c751&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b70c751",
  null
  
)

export default component.exports